const heroImg =
  "https://readdy.ai/api/search-image?query=A%20playful%20isometric%20illustration%20of%20people%20eating%20watermelon%20around%20a%20floating%20timeline%20of%20news%20cards%20and%20popcorn%2C%20warm%20cream%20background%2C%20watermelon%20red%20and%20soft%20green%20accents%2C%20flat%20vector%20style%2C%20soft%20rounded%20shapes%2C%20cozy%20and%20fun%20editorial%20illustration&width=1600&height=1000&seq=gua-hero-01&orientation=landscape";

const chips = ["爆发", "发酵", "高潮", "反转", "进展", "尾声"];

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={heroImg}
          alt="一群年轻人围坐吃西瓜查看事件时间线的趣味插画"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-950/55 via-background-950/35 to-background-50"></div>
      </div>

      <div className="relative mx-auto flex min-h-[560px] max-w-7xl flex-col items-center justify-center px-4 py-28 text-center md:min-h-[640px] md:py-32 md:px-6">
        <div className="flex items-center gap-2 rounded-full bg-background-50/20 px-4 py-1.5 backdrop-blur-sm">
          <span className="flex h-5 w-5 items-center justify-center rounded-full bg-accent-500">
            <i className="ri-flashlight-line text-xs text-background-50"></i>
          </span>
          <span className="text-xs font-medium text-background-50 md:text-sm">全网热点 · 一次补课</span>
        </div>

        <h1 className="mt-6 max-w-3xl font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl md:leading-tight">
          吃瓜不迷路，<span className="text-accent-300">一眼看穿</span>事件始末
        </h1>
        <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-100 md:text-base">
          我们为每起正在发酵的热点事件整理「爆发 → 发酵 → 高潮 → 反转」的完整时间线。
          无论你错过多少细节，都能花几分钟快速补课，理清始末，看懂最新进展，成为朋友圈里最懂瓜的人。
        </p>

        <div className="mt-7 flex flex-wrap items-center justify-center gap-2">
          {chips.map((c) => (
            <span
              key={c}
              className="flex items-center gap-1 whitespace-nowrap rounded-full bg-background-50/15 px-3.5 py-1.5 text-xs font-medium text-background-50 backdrop-blur-sm"
            >
              <i className="ri-time-line text-xs text-accent-300"></i>
              {c}
            </span>
          ))}
        </div>

        <div className="mt-9 flex flex-col items-center gap-3 sm:flex-row">
          <a
            href="#timeline"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3.5 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
          >
            开始吃瓜
            <i className="ri-arrow-right-line text-base"></i>
          </a>
          <a
            href="#trending"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-50/40 bg-background-50/10 px-7 py-3.5 text-sm font-bold text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/20"
          >
            看今日热榜
            <i className="ri-fire-line text-base text-secondary-300"></i>
          </a>
        </div>
      </div>
    </section>
  );
}